import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFade } from "swiper/modules"
import 'swiper/css';
import 'swiper/css/effect-fade';
import ProductImg from '../../assets/shoe.webp'
import ProductImg2 from '../../assets/wristwatch.jpg'

const ShowcaseSlider = () => {

    return (
        <Swiper
            slidesPerView={1}
            loop={true}
            effect={'fade'}
            centeredSlides={true}
            autoplay={{
                delay: 3000,
                disableOnInteraction: false
            }}
            modules={[Autoplay, EffectFade]}
            className=" h-full"
        >
            <SwiperSlide>
                <img src={ProductImg} className=' w-full h-full object-cover' alt="" />
            </SwiperSlide>
            <SwiperSlide>
                <img src={ProductImg2} className=' w-full h-full object-cover' alt="" />
            </SwiperSlide>
        </Swiper>
    )
}

export default ShowcaseSlider